<template>
  <div class="chart-type-selector">
    <ul class="chart-type-selector__list">
      <li
        v-for="(option, i) of options"
        :key="i"
        v-tooltip="{
          content: disabledOptions[i] != null ? disabledMessages[i] : null,
          classes: ['disabled-on-flip']
        }"
        :class="[
          'chart-type-selector__item',
          option,
          value === option ? 'selected' : '',
          disabledOptions[i] != null ? 'disabled' : '',
        ]"
        @click="value = (!disabledOptions[i] && option) || value"
      />
    </ul>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'chart',
    event: 'change',
  },
  props: ['chart', 'options', 'disablements'],
  computed: {
    value: {
      get() {
        return this.chart
      },
      set(value) {
        this.$emit('change', value)
      },
    },
    disableds() {
      const disablements = this.disablements || []
      return this.options.reduce((acum, opt) => {
        return acum.concat([disablements.find(d => d[0] == opt) || null])
      }, [])
    },
    disabledOptions() {
      return this.disableds.map(d => d && d[0])
    },
    disabledMessages() {
      return this.disableds.map(d => d && d[1])
    },
  },
  watch: {
    value: {
      handler(to, from) {
        if (!to) {
          if (/stan_/i.test(this.$store.state.query.mainCubeId)) {
            this.value = 'linechart'
          } else if (/gd_breakdowns_21/i.test(this.$store.state.query.mainCubeId)) {
            this.value = 'heatmap'
          } else {
            this.value = this.options[0]
          }
        }
      },
      immediate: true,
    },
    disableds(to, from) {
      if (to.includes(this.value)) {
        if (/stan_/i.test(this.$store.state.query.mainCubeId)) {
          this.value = 'linechart'
        } else if (/gd_breakdowns_21/i.test(this.$store.state.query.mainCubeId)) {
          this.value = 'heatmap'
        } else {
          this.value = this.options[0]
        }
      }
    },
  },
  beforeMount() {
    if (this.disableds.includes(this.value)) this.value = this.options[0]
  },
}
</script>

<style lang="stylus">
.chart-type-selector
  display: block

  .mobile &
    display: none

  &.responsive
    position: absolute
    bottom: 0px
    left: 0
    display: block
    height: vw(50px)
    width: 100%
    background-color: #fff
    border-top: 1px solid rgba($dark-gray, 0.2)
    padding-right: unset
    z-index: 1
    display: none

    .mobile &
      display: block

      +m-breakpoint(landscape)
        height: vh(55px)

.chart-type-selector__list
  align-items: center
  display: flex

  .mobile &
    height: 100%

.chart-type-selector__item
  align-items: center
  cursor: pointer
  display: flex
  height: vw(60px)
  justify-content: center
  position: relative
  width: vw(60px)

  .mobile &
    height: vw(50px)
    width: 25%

    +m-breakpoint(landscape)
      height: vh(50px)

  &.disabled
    cursor: default
    opacity: 0.4

  &:not(:last-child)
    &:after
      background-color: $gray
      content: ""
      height: 75%
      position: absolute
      right: 0
      top: 50%
      transform: translateY(-50%)
      width: 1px

  $icons = "barchart", "linechart", "heatmap", "choropleth", "table"

  for $icon in $icons
    &.{$icon}
      &:before
        m-icon($icon, 30)
        content: ""

        .mobile &
          m-icon($icon, 25)

          +m-breakpoint(landscape)
            m-icon($icon, 15)

      &.selected
        &:before
          m-icon($icon + "-active", 30)
          content: ""

          .mobile &
            m-icon($icon + "-active", 25)

            +m-breakpoint(landscape)
              m-icon($icon + "-active", 15)

</style>
